import styles from './MaskTabPanel.module.scss';

import clsx from 'clsx';

import { useMaskTabContext } from './MaskTabContext';
import { MaskTabPanelContext } from './MaskTabPanelContext';

export interface MaskTabPanelProps {
  value: string | number;
  children?: React.ReactNode;
  className?: string;
  /**
   * Whether inactive tab panels should be made non-interactive and inaccessible
   * using the `inert` attribute. This keeps all panels mounted in the DOM but
   * prevents user interaction and hides them from assistive technologies.
   *
   * Defaults to `true`.
   */
  useInert?: boolean;
}

export function MaskTabPanel(props: MaskTabPanelProps) {
  const { value, children, className, useInert = true } = props;

  const context = useMaskTabContext();

  const isActive = context.value === value;

  const comp = useInert ? (
    <div
      role="tabpanel"
      id={`tabpanel-${value}`}
      aria-labelledby={`tab-${value}`}
      hidden={!isActive}
      inert={!isActive}
      className={clsx(styles.maskTabPanelContent, className)}
    >
      {children}
    </div>
  ) : (
    isActive && (
      <div className={clsx(styles.maskTabPanelContent, className)}>
        {children}
      </div>
    )
  );

  return <MaskTabPanelContext value={value}>{comp}</MaskTabPanelContext>;
}
